import React, { useEffect, useState } from "react";

import { ChannelContainer, Container, Divider, Title, InputContainer } from "./styles";
import { Checkbox } from "@mui/material";
import { useUser } from "../../contexts/UserContext";
import FollowConfig from "../FollowConfig";
import Translator from "../../components/i18nComponents/Translator";
import { useTranslation } from "react-i18next";

export default function ConfigureFollow() {

  const { tradersList, handleGetTraders } = useUser();
  const [enableAdvance, setEnable] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    handleGetTraders();
  }, []);

  return (
    <Container>
      <Title><Translator path="paginas.copyTrader.Title"/></Title>
      <Divider />

      {/* Contêiner flexível para alinhar Checkbox e texto */}
      <InputContainer style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Checkbox
          checked={enableAdvance}
          name="enableAdvance"
          id="idEn"
          onChange={() => setEnable(!enableAdvance)}
        />
        <div>{t("componentes.ChannelCardComponente.advanceBox")}</div>
      </InputContainer>

      <ChannelContainer>
        {tradersList.map((trader, index) => (
          <FollowConfig trader={trader} key={index} enableAdvance={enableAdvance} />
        ))}
      </ChannelContainer>
    </Container>
  );
}
